import uniq from "lodash/uniq";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { keySeparator } from "views/Constants";
export const createSelectedEntityId = (index, id) => `${index}${keySeparator}${id}`;
const splitSelectedEntityId = (selectedEntityId) => {
  const [index, id] = selectedEntityId.split(keySeparator);
  return { index, id };
};
const useSelectedMessageEntities = () => {
  const { setSelectedEntities, isAllRowsSelected, isSomeRowsSelected, toggleEntitySelect, selectedEntities } = useSelectedEntities();
  const _toggleEntitySelect = (index, id) => toggleEntitySelect(createSelectedEntityId(index, id));
  const toggleAllEntitySelect = (data) => {
    setSelectedEntities((cur) => {
      const entityIds = data.map(({ id, index }) => createSelectedEntityId(index, id));
      if (isAllRowsSelected) {
        return cur.filter((itemId) => !entityIds.includes(itemId));
      }
      return uniq([...cur, ...entityIds]);
    });
  };
  const isEntitySelected = (index, id) => selectedEntities.includes(createSelectedEntityId(index, id));
  const _selectedEntities = selectedEntities.map((selectedEntityId) => splitSelectedEntityId(selectedEntityId));
  return {
    toggleAllEntitySelect,
    toggleEntitySelect: _toggleEntitySelect,
    isSomeRowsSelected,
    isEntitySelected,
    selectedEntities: _selectedEntities,
    isAllRowsSelected
  };
};
export default useSelectedMessageEntities;
